import PropTypes from 'prop-types';

import { bound, clsm, noop } from '../../../../../../utils';
import Input from '../../../../../../components/Input';
import InputRange from '../../../../../../components/InputRange';
import Label from '../../../../../../components/Input/InputLabel';

const RangeSelector = ({
  dataKey,
  label = '',
  max = 100,
  min = 0,
  name,
  updateData = noop,
  value = 0
}) => {
  const handleOnChange = (value) => {
    updateData({ [dataKey]: parseInt(value) });
  };

  const handleInputOnBlur = ({ target }) => {
    updateData({ [dataKey]: parseInt(bound(target.value, min, max)) });
  };

  return (
    <div>
      {label && <Label label={label} htmlFor={name} />}
      <div className={clsm(['flex', 'space-x-4', 'items-center'])}>
        <InputRange
          onChange={handleOnChange}
          name={`${name}-range-input`}
          value={value || min}
          min={min}
          max={max}
          className={clsm(['!w-full'])}
        />
        <Input
          type="number"
          name={name}
          className={clsm(['w-[92px]', 'dark:bg-darkMode-gray-dark'])}
          value={value.toString()}
          onChange={({ target }) => handleOnChange(target.value)}
          onBlur={handleInputOnBlur}
          min={min}
          max={max}
          variant="horizontal"
          autoComplete="off"
        />
      </div>
    </div>
  );
};

RangeSelector.propTypes = {
  dataKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  updateData: PropTypes.func,
  value: PropTypes.number
};

export default RangeSelector;
